<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0">
          <span>
            <span>Detalle de Pedido #{{ order.code }}</span>

            <template v-if="order.projection && $can('show', 'projections')">
              (basado en
              <router-link :to="{ name: 'ProjectionShow', params: { id: order.projection.id } }">
                Proyección </router-link
              >)
            </template>
          </span>

          <badge v-if="order.state" :type="getColor(order)" class="float-right">
            {{ order.state.label }}
          </badge>
        </h3>
      </div>

      <div class="card-body">
        <div v-if="isOrderOpen" class="row mb-0">
          <div class="col-sm-12">
            <!--            <router-link :to="{name: 'OrderEdit', params: { id: order.id }}"-->
            <!--                         class="btn btn-link btn-sm btn-fill btn-wd float-right"-->
            <!--                         v-if="$can('store', 'orders')">-->
            <!--              <i class="fas fa-pen mr-1"></i>Editar-->
            <!--            </router-link>-->
          </div>
        </div>
        <div v-if="isOrderAccepted" class="row mb-0">
          <div class="col-sm-12">
            <button
              class="btn btn-dark btn-sm btn-fill btn-wd float-right"
              title="Descargar"
              @click="$emit('download-pdf')"
            >
              <i class="fas fa-download"></i>&nbsp;Descargar PDF
            </button>
          </div>
        </div>

        <order-info :campaign="order.campaign" :order-date="order.date" :producer="order.producer" :user="order.user" />

        <hr />
        <order-header :order="order" />

        <hr />
        <order-items-list
          v-if="order.items.length > 0"
          :add="false"
          :dollar-quote="dollarQuote"
          :edit="false"
          :items="order.items"
          :order-id="order.id"
        />

        <h2 v-else class="font-weight-normal">Sin artículos.</h2>

        <change-state
          :is-order-open="isOrderOpen"
          :is-order-pending="isOrderPending"
          :on-changing-state="onChangingState"
          :order="order"
          :order-id="orderId"
        />
      </div>
    </div>

    <change-state-form
      v-if="onChangingState"
      :title="changeStateForm.title"
      :model-validations="changeStateForm.validations"
      @cancel="onChangingState = false"
    />
  </div>
</template>

<script>
import OrderEventBus from '@/events/buses/orders.event';
import OrderStatesMixin from '@/mixins/orderStatesMixin';
import OrderInfo from './OrderInfo';
import OrderHeader from './OrderHeader';
import OrderItemsList from '../List/OrderItemsList';
import ChangeStateForm from '../Forms/ChangeStateForm';
import ChangeState from '../Components/ChangeState';
import { getDollarQuote } from '@/util/orders';

export default {
  components: {
    OrderInfo,
    OrderHeader,
    OrderItemsList,
    ChangeState,
    ChangeStateForm,
  },

  mixins: [OrderStatesMixin],
  props: {
    order: {
      type: Object,
      required: true,
    },

    orderId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      onChangingState: false,
      changeStateForm: {
        title: 'Cerrar Pedido',
        info: '',
        validations: {
          comment: {
            required: false,
          },
        },

        inputs: {
          comment: {
            label: '',
            placeholder: '',
            required: true,
          },
        },
      },
    };
  },

  computed: {
    dollarQuote() {
      return getDollarQuote(this.order);
    },
  },

  created() {
    OrderEventBus.$on('orders-on-changing-state', this.changingState);
    OrderEventBus.$on('orders-on-accept', this.onAcceptOrder);
    OrderEventBus.$on('orders-on-cancel', this.onCancelOrder);
    OrderEventBus.$on('orders-on-reject', this.onRejectOrder);
  },

  beforeDestroy() {
    OrderEventBus.$off('orders-on-changing-state', this.changingState);
    OrderEventBus.$off('orders-on-accept', this.onAcceptOrder);
    OrderEventBus.$off('orders-on-cancel', this.onCancelOrder);
    OrderEventBus.$off('orders-on-reject', this.onRejectOrder);
  },

  methods: {
    onAcceptOrder() {
      // setear los datos y pasar al form de comment si es necesario
      this.changeStateForm.title = 'Aceptar Pedido';
      this.changeStateForm.validations.comment.required = false;
    },

    onCancelOrder() {
      this.changeStateForm.title = 'Cancelar Pedido';
      this.changeStateForm.validations.comment.required = true;
    },

    onRejectOrder() {
      // setear los datos y pasar al form de comment si es necesario
      this.changeStateForm.title = 'Rechazar Pedido';
      this.changeStateForm.validations.comment.required = true;
    },

    changingState(changing) {
      this.onChangingState = changing;
    },
  },
};
</script>
